import {toCurrency} from './functions';
import {setSystemToLowercase} from './serverFunctions';

/**
 * Return the appropriate value for Price column
 *
 * @param locationObj
 * @param price
 */
export const getPriceFromLocation = (locationObj, price) => {
    const locationID = locationObj.id.toString();
    const dbaPriceLevel = locationObj.dbaPriceLevel;
    const locationPriceLevel = locationObj.priceLevel;
    let storedPriceLevel = null;
    let defaultPrice = null;
    let levelPrice = null;
    let locationPrice = null;

    // Select either the DBA Price Level or Location Price Level
    if (locationObj.productType && dbaPriceLevel) {
        storedPriceLevel = dbaPriceLevel;
    }
    if (locationPriceLevel) {
        storedPriceLevel = locationPriceLevel;
    }

    for (const [key, value] of Object.entries(price)) {
        if (key === 'location_' + locationID) {
            locationPrice = value;
        }
        if (key === 'default') {
            defaultPrice = value;
        }
        if (key === storedPriceLevel) {
            levelPrice = value;
        }
    }
    if (locationPrice) {
        return locationPrice;
    }
    if (levelPrice) {
        return levelPrice;
    }
    return defaultPrice;
};

/**
 * Retrieve Price values to calculate Product columns (sell price, overage/shrink values)
 *
 * @param location
 * @param productId
 * @param variance
 * @param priceList
 */
export const setPriceValues = (location, productId, variance, priceList) => {
    const priceIdx = priceList.findIndex(p => p.product_id.toString() === productId);
    let sellPrice = '0.00';
    let shrinkValue = '0.00';
    let overageValue = '0.00';
    let shrinkOverageMult = 0;
    if (priceIdx !== -1 && priceList[priceIdx].price) {
        // Extract the desired price for Sell Price column (skip if no price object exists)
        sellPrice = toCurrency(getPriceFromLocation(location, priceList[priceIdx].price));
        // Populate either shrinkValue or overageValue
        shrinkOverageMult = (sellPrice * variance);
        if (shrinkOverageMult === 0) {
            overageValue = '0.00';
            shrinkValue = '0.00';
        } else if (shrinkOverageMult > 0) {
            overageValue = toCurrency(shrinkOverageMult);
            shrinkValue = '0.00';
        } else if (shrinkOverageMult < 0) {
            overageValue = '0.00';
            shrinkValue = toCurrency(shrinkOverageMult);
        }
    }
    return {
        sellPrice: sellPrice,
        shrinkValue: shrinkValue,
        overageValue: overageValue
    };
};

/**
 * Retrieve Category data for a Product from a price list
 *
 * @param productId
 * @param priceList
 * @returns {{category: (string|*), categoryId: (string)}}
 */
 export const setProductCategories = (productId, priceList) => {
     const priceIdx = priceList.findIndex(p => p.product_id.toString() === productId);
     return {
         category: (priceIdx !== -1) ? priceList[priceIdx].category : '',
         categoryId: (priceIdx !== -1) ? priceList[priceIdx].category_id : ''
     };
 };

/**
 * Assemble a payload object for Combined Sales and Scheduled Reports
 *
 * @returns {{mode: string, system: string, dateRange: {fromDay: string, tz: string, toDay: string, daysBack: number}, location: {cities: *[], districts: *[], locations: *[], dbas: *[], states: *[]}}}
 */
export const assembleReportPayload = () => {
    return {
        dateRange: {
            daysBack: 0,
            fromDay: '',
            toDay: '',
            tz: ''
        },
        location: {
            cities: [],
            dbas: [],
            districts: [],
            locations: [],
            states: [],
        },
        mode: encodeURIComponent(localStorage.getItem('mode')),
        system: setSystemToLowercase()
    }
};


// WEBPACK FOOTER //
// ./src/Fuse/shared/reportFunctions.js